import {Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild} from '@angular/core';
import {NgbNav, NgbNavChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {NavTabComponent} from "../nav-tab/nav-tab.component";

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent {
  @ContentChildren(NavTabComponent) tabs: QueryList<NavTabComponent> | undefined;
  @Input() reduceHorizontalSpacing: boolean | false = false;
  @Input() active: number | undefined;
  @Output() onChange: EventEmitter<number | undefined> = new EventEmitter<number | undefined>();
  @Input() tabCssClass: string | undefined
  @ViewChild("nav") nav?: NgbNav;
  @Input() areTabsCentered: boolean = false;
  @Input() isMeasurementTabActive: boolean = false;

  select(id: number) {
    this.nav?.select(id);
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    this.onChange.emit(changeEvent.nextId)
  }

  isLastTab(tab: NavTabComponent): boolean {
    if (!this.tabs) {
      return false;
    }
    const tabsArray = this.tabs.toArray();
    return tabsArray.indexOf(tab) === tabsArray.length - 1;
  }

}
